module.exports = __webpack_public_path__ + "static/media/ico-chek.5779b59a.svg";